import styled from 'styled-components'
import { tokens, CircleButton } from '@arvoreeducacao/bonsai-ds'

export const BackArrowButton = styled(CircleButton)`
  top: 0;
  margin-right: auto;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    position: absolute;
    left: 70px;
    top: 70px;
    margin-right: 0;
  }
`

export const PageWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
`

export const Content = styled.div`
  width: 90%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    width: 400px;
  }
  @media (min-width: ${tokens.sizes.mdScreen}px) {
    width: 530px;
  }
`

export const Title = styled.p`
  width: 100%;
  font-size: ${tokens.sizes.h[4].tablet};
  line-height: 30px;
  font-weight: bold;
  color: ${tokens.colors.black6};
  margin: 0 auto 0 0;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    margin: 70px 0 5px 0;
    width: 100%;
  }
`

export const SubTitle = styled.p`
  width: 100%;
  font-size: ${tokens.sizes.text}px;
  line-height: 28px;
  color: ${tokens.colors.black6};
  margin: 0;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    margin: 0;
    width: 100%;
  }
`
